const scrollToDivById = (id) => {
  const target = document.getElementById(id);
  if (target) {
    // Get the sticky header height
    const stickyHeader = document.querySelector(".fixed.z-20"); // Adjust selector if needed
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

    // Get the target's position
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;

    // Scroll to the target position minus the header height
    window.scrollTo({
      top: targetPosition - headerHeight - 10,
      behavior: "smooth",
    });
  }
};

export default scrollToDivById;
